"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var FadeoutBottom_1 = __importDefault(require("atomicComponents/atoms/Scroll/FadeoutBottom"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var context_1 = __importDefault(require("components/Money/context"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var single_1 = require("utils/selectors/single");
var context_2 = require("./context");
var tableConf_1 = require("./tableConf");
var TransactionHeader_1 = __importDefault(require("./TransactionHeader"));
var utils_1 = require("./utils");
var Header = (0, HeaderMaker_1.default)(tableConf_1.transactionsTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.transactionsTableConf);
var Transactions = function (_a) {
    var serviceStat = _a.serviceStat, transactions = _a.transactions;
    var _b = __read(react_1.default.useState(false), 2), displayCurrency = _b[0], setDisplayCurrency = _b[1];
    var _c = __read(react_1.default.useState(false), 2), displayDecimal = _c[0], setDisplayDecimal = _c[1];
    var myCompany = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var sortedTransactions = (0, hooks_1.useSortArray)(transactions, __assign(__assign({}, tableConf_1.transactionsTableConf.extractors), { amount: (0, utils_1.convertTxnAmount)(myCompany) }));
    var moneyContextVal = (0, react_1.useMemo)(function () { return ({ isRounded: !displayDecimal }); }, [displayDecimal]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mb: 3 }, { children: (0, jsx_runtime_1.jsx)(TransactionHeader_1.default, { serviceStat: serviceStat, transactions: transactions, activateCurrencySource: displayCurrency, activateDecimal: displayDecimal, currencyBtnOnClick: setDisplayCurrency, decimalBtnOnClick: setDisplayDecimal }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ position: "relative", height: "calc(100% - 76px)" }, { children: (0, jsx_runtime_1.jsx)(context_2.ShowCurrencyContext.Provider, __assign({ value: displayCurrency }, { children: (0, jsx_runtime_1.jsx)(context_1.default.Provider, __assign({ value: moneyContextVal }, { children: (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ pb: 8, hasActionCell: !!tableConf_1.transactionsTableConf.cells.find(function (c) { var _a; return (_a = c.cell) === null || _a === void 0 ? void 0 : _a.isActionCell; }) }, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: sortedTransactions === null || sortedTransactions === void 0 ? void 0 : sortedTransactions.map(function (transaction) { return ((0, jsx_runtime_1.jsx)(Row, { item: transaction, isHidden: transaction.isHidden }, transaction.id)); }) }), (0, jsx_runtime_1.jsx)(FadeoutBottom_1.default, { height: 80 })] })) })) })) }))] }));
};
exports.default = (0, SortHoC_1.default)(Transactions, { key: 'date', order: -1 });
